// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { 
//   FiUsers, 
//   FiCheckCircle, 
//   FiXCircle, 
//   FiSearch, 
//   FiLogOut, 
//   FiRefreshCw, 
//   FiShield, 
//   FiChevronDown, 
//   FiMail, 
//   FiPhone, 
//   FiClock, 
//   FiActivity ,
//   FiCreditCard,
//   FiEye,
//   FiDollarSign
// } from 'react-icons/fi';
// import { RiAdminLine, RiDashboardLine } from 'react-icons/ri';

// const colors = {
//   orange: '#f35018',
//   blue: '#2f3194',
//   deepNavy: '#0b0c26',
//   surfaceDark: '#16183e',
//   cyan: '#63decc',
//   white: '#ffffff',
//   textMain: '#0f1137',
//   bgLight: '#f4f6fc',
//   muted: '#64748b',
//   border: '#e2e8f0',
//   success: '#10b981',
//   danger: '#ef4444',
//   gold: '#fbbf24',
// };

// const BASE_URL = 'https://rvapi.emedha.in/auth/api';

// export default function AdminDashboard() {
//   const navigate = useNavigate();
//   const [adminUser, setAdminUser] = useState(null);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [hosts, setHosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [actionLoadingId, setActionLoadingId] = useState(null);
//   // --- Payment Verifications States ---
//   const [activeTab, setActiveTab] = useState('hosts'); // 'hosts' | 'payments'
//   const [paymentRequests, setPaymentRequests] = useState([]);
//   const [paymentsLoading, setPaymentsLoading] = useState(false);
//   const [previewImage, setPreviewImage] = useState(null); // URL for zoomed screenshot modal
//   const [approvingPaymentId, setApprovingPaymentId] = useState(null);

//   const dropdownRef = useRef(null);

//   // Authentication Guard & Data Load
//   useEffect(() => {
//     const stored = sessionStorage.getItem('admin_user');
//     if (!stored) {
//       navigate('/admin-login');
//       return;
//     }
//     setAdminUser(JSON.parse(stored));
//     fetchHosts();

//     // Close profile dropdown on outside click
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [navigate]);

//   const fetchHosts = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${BASE_URL}/api/admin/hosts`).catch(() => {
//         return axios.get(`${BASE_URL}/admin/hosts`);
//       });

//       if (res.data?.success && Array.isArray(res.data.hosts)) {
//         setHosts(res.data.hosts);
//       }
//     } catch (err) {
//       console.error('Failed to load hosts:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleToggleApproval = async (host) => {
//     try {
//       setActionLoadingId(host.id);
//       const res = await axios.post(`${BASE_URL}/api/admin/toggle-approval`, {
//         hostId: host.id,
//         currentStatus: host.isApprove,
//         email: host.email,
//         name: host.name,
//       }).catch(() => {
//         return axios.post(`${BASE_URL}/admin/toggle-approval`, {
//           hostId: host.id,
//           currentStatus: host.isApprove,
//           email: host.email,
//           name: host.name,
//         });
//       });

//       if (res.data?.success) {
//         setHosts((prev) =>
//           prev.map((h) => (h.id === host.id ? { ...h, isApprove: res.data.newStatus } : h))
//         );
//       }
//     } catch (err) {
//       alert('Failed to update host approval status.');
//     } finally {
//       setActionLoadingId(null);
//     }
//   };


//   // Load payments from backend
//   const fetchPayments = async () => {
//     try {
//       setPaymentsLoading(true);
//       const res = await axios.get(`${BASE_URL}/api/admin/payment-requests`).catch(() => {
//         return axios.get(`${BASE_URL}/admin/payment-requests`);
//       });
//       if (res.data?.success && Array.isArray(res.data.payments)) {
//         setPaymentRequests(res.data.payments);
//       }
//     } catch (err) {
//       console.error('Failed to load payment requests:', err);
//     } finally {
//       setPaymentsLoading(false);
//     }
//   };

//   // Fetch payments on initial load too
//   useEffect(() => {
//     fetchPayments();
//   }, []);

//   // Approve or Reject Payment
//   const handlePaymentAction = async (paymentId, action) => {
//     const confirmMsg = action === 'approved' 
//       ? 'Verify and activate this subscription for 30 days?' 
//       : 'Reject this payment verification proof?';
//     if (!window.confirm(confirmMsg)) return;

//     try {
//       setApprovingPaymentId(paymentId);
//       const res = await axios.post(`${BASE_URL}/api/admin/approve-payment`, {
//         paymentId,
//         action
//       }).catch(() => {
//         return axios.post(`${BASE_URL}/admin/approve-payment`, {
//           paymentId,
//           action
//         });
//       });

//       if (res.data?.success) {
//         alert(res.data.message || 'Payment updated successfully!');
//         // Update local state
//         setPaymentRequests(prev => prev.map(p => p.id === paymentId ? { ...p, status: action } : p));
//         // Refresh hosts table so new plan tier reflects
//         fetchHosts();
//       }
//     } catch (err) {
//       console.error('Action error:', err);
//       alert(err.response?.data?.message || 'Failed to update payment status.');
//     } finally {
//       setApprovingPaymentId(null);
//     }
//   };



//   const handleLogout = () => {
//     sessionStorage.removeItem('admin_user');
//     navigate('/admin-login');
//   };

//   // Filter accounts by name, email, or mobile
//   const filteredHosts = hosts.filter((h) => {
//     const q = searchQuery.toLowerCase();
//     return (
//       (h.name && h.name.toLowerCase().includes(q)) ||
//       (h.email && h.email.toLowerCase().includes(q)) ||
//       (h.mobile && h.mobile.includes(q))
//     );
//   });


//   const approvedCount = hosts.filter((h) => h.isApprove === 1).length;
//   const pendingCount = hosts.length - approvedCount;
//   const pendingPaymentsCount = paymentRequests.filter((p) => p.status === 'pending').length;

//   // Filter payments by search
//   const filteredPayments = paymentRequests.filter((p) => {
//     const q = searchQuery.toLowerCase();
//     return (
//       (p.full_name && p.full_name.toLowerCase().includes(q)) ||
//       (p.email && p.email.toLowerCase().includes(q)) ||
//       (p.transaction_id && p.transaction_id.toLowerCase().includes(q)) ||
//       (p.plan_name && p.plan_name.toLowerCase().includes(q))
//     );
//   });

//   return (
//     <div style={styles.dashboardWrapper}>
//       {/* 1. TOP EXECUTIVE HEADER */}
//       <header style={styles.header}>
//         <div style={styles.headerInner}>
//           {/* Brand Logo & Tag */}
//           <div style={styles.brandRow}>
//             <div style={styles.logoBadge}>
//               <RiDashboardLine size={20} color={colors.cyan} />
//             </div>
//             <div>
//               <h2 style={styles.brandTitle}>
//                 Quizify<span style={{ color: colors.orange }}>AI</span>
//                 <span style={styles.adminBadge}>ADMIN</span>
//               </h2>
//             </div>
//           </div>

//           {/* Right Profile Dropdown Area */}
//           <div style={styles.profileSection} ref={dropdownRef}>
//             <button
//               onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//               style={styles.profileBtn}
//             >
//               <div style={styles.avatar}>
//                 <RiAdminLine size={18} color={colors.white} />
//               </div>
//               <div style={styles.profileMeta}>
//                 <span style={styles.profileRole}>SUPER ADMIN</span>
//                 <span style={styles.profileEmail}>{adminUser?.email || 'admin@quizifyai.in'}</span>
//               </div>
//               <FiChevronDown
//                 size={16}
//                 color={colors.muted}
//                 style={{
//                   transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//                   transition: 'transform 0.2s',
//                 }}
//               />
//             </button>

//             {/* Dropdown Menu */}
//             {isDropdownOpen && (
//               <div style={styles.dropdownMenu}>
//                 <div style={styles.dropdownHeader}>
//                   <p style={styles.dropdownLabel}>Signed in as</p>
//                   <p style={styles.dropdownUserEmail}>{adminUser?.email}</p>
//                 </div>
//                 <div style={styles.divider} />
//                 <button onClick={handleLogout} style={styles.logoutBtn}>
//                   <FiLogOut size={16} color={colors.danger} />
//                   <span>Log Out</span>
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </header>

//       {/* 2. MAIN BODY CONTENT */}
//       <main style={styles.mainContainer}>
//         {/* KPI METRIC CARDS */}
//       {/* KPI METRIC CARDS */}
//         <div style={styles.kpiGrid}>
//           <div style={styles.kpiCard}>
//             <div style={styles.kpiIconWrap(colors.blue)}>
//               <FiUsers size={22} color={colors.blue} />
//             </div>
//             <div>
//               <p style={styles.kpiLabel}>TOTAL REGISTERED HOSTS</p>
//               <h3 style={styles.kpiValue}>{hosts.length}</h3>
//             </div>
//           </div>

//           <div style={styles.kpiCard}>
//             <div style={styles.kpiIconWrap(colors.success)}>
//               <FiCheckCircle size={22} color={colors.success} />
//             </div>
//             <div>
//               <p style={styles.kpiLabel}>APPROVED HOSTS</p>
//               <h3 style={{ ...styles.kpiValue, color: colors.success }}>{approvedCount}</h3>
//             </div>
//           </div>

//           <div style={styles.kpiCard}>
//             <div style={styles.kpiIconWrap(colors.orange)}>
//               <FiClock size={22} color={colors.orange} />
//             </div>
//             <div>
//               <p style={styles.kpiLabel}>PENDING APPROVALS</p>
//               <h3 style={{ ...styles.kpiValue, color: colors.orange }}>{pendingCount}</h3>
//             </div>
//           </div>

//           <div 
//             style={{ ...styles.kpiCard, cursor: 'pointer', border: activeTab === 'payments' ? `2px solid ${colors.blue}` : `1px solid ${colors.border}` }}
//             onClick={() => setActiveTab('payments')}
//           >
//             <div style={styles.kpiIconWrap(colors.gold)}>
//               <FiCreditCard size={22} color="#b45309" />
//             </div>
//             <div>
//               <p style={styles.kpiLabel}>PENDING PAYMENTS</p>
//               <h3 style={{ ...styles.kpiValue, color: '#b45309' }}>{pendingPaymentsCount}</h3>
//             </div>
//           </div>
//         </div>

//         {/* TAB NAVIGATION SWITCHER */}
//         <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//           <button
//             onClick={() => setActiveTab('hosts')}
//             style={{
//               padding: '10px 20px',
//               borderRadius: '12px',
//               border: 'none',
//               fontWeight: '700',
//               fontSize: '13px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px',
//               backgroundColor: activeTab === 'hosts' ? colors.blue : colors.white,
//               color: activeTab === 'hosts' ? colors.white : colors.muted,
//               boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
//             }}
//           >
//             <FiUsers size={16} /> Host Accounts ({hosts.length})
//           </button>

//           <button
//             onClick={() => setActiveTab('payments')}
//             style={{
//               padding: '10px 20px',
//               borderRadius: '12px',
//               border: 'none',
//               fontWeight: '700',
//               fontSize: '13px',
//               cursor: 'pointer',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px',
//               backgroundColor: activeTab === 'payments' ? colors.blue : colors.white,
//               color: activeTab === 'payments' ? colors.white : colors.muted,
//               boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
//             }}
//           >
//             <FiCreditCard size={16} /> Payment Verifications
//             {pendingPaymentsCount > 0 && (
//               <span style={{
//                 backgroundColor: colors.orange,
//                 color: '#fff',
//                 fontSize: '10px',
//                 padding: '2px 7px',
//                 borderRadius: '10px',
//                 marginLeft: '4px'
//               }}>
//                 {pendingPaymentsCount} NEW
//               </span>
//             )}
//           </button>
//         </div>

//         {/* 3. HOST ACCOUNTS TABLE CARD */}
//         <div style={styles.tableCard}>
    
//          {/* Card Header & Search Controls */}
         
//           <div style={styles.tableControlRow}>
//             <div>
//               <h3 style={styles.cardHeading}>
//                 {activeTab === 'hosts' ? 'Host Accounts Management' : 'Payment Verification Requests'}
//               </h3>
//               <p style={styles.cardSub}>
//                 {activeTab === 'hosts' 
//                   ? 'Review registered hosts, verify OTP states, and toggle match deployment authorization.' 
//                   : 'Review UPI payment proofs, inspect transaction UTRs, and activate 30-day subscription quotas.'}
//               </p>
//             </div>

//             <div style={styles.actionControls}>
//               {/* Search Bar */}
//               <div style={styles.searchBox}>
//                 <FiSearch size={16} color={colors.muted} style={{ marginRight: '8px' }} />
//                 <input
//                   type="text"
//                   placeholder={activeTab === 'hosts' ? "Search name, email, mobile..." : "Search name, UTR, plan..."}
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   style={styles.searchInput}
//                 />
//               </div>

//               {/* Refresh Button */}
//               <button onClick={activeTab === 'hosts' ? fetchHosts : fetchPayments} style={styles.refreshBtn} title="Refresh Table">
//                 <FiRefreshCw size={16} color={colors.blue} className={(loading || paymentsLoading) ? 'spin' : ''} />
//               </button>
//             </div>
//           </div>

//           {/* Table View */}
//           <div style={styles.tableContainer}>
//            {activeTab === 'hosts' && (
//             <div style={styles.tableContainer}>
//               <table style={styles.table}>
//                 <thead>
//                   <tr style={styles.tableHeadRow}>
//                     <th style={styles.th}>ID</th>
//                     <th style={styles.th}>HOST IDENTITY</th>
//                     <th style={styles.th}>CONTACT</th>
//                     <th style={styles.th}>REGISTRATION DATE</th>
//                     <th style={styles.th}>OTP VERIFIED</th>
//                     <th style={styles.th}>TRIAL / PLAN STATUS</th>
//                     <th style={styles.th}>APPROVAL STATUS</th>
//                     <th style={{ ...styles.th, textAlign: 'center' }}>ACTION</th>
//                   </tr>
//                 </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="7" style={styles.loadingCell}>
//                       <FiActivity size={24} color={colors.cyan} className="spin" />
//                       <p style={{ marginTop: '10px', color: colors.muted, fontSize: '13px' }}>
//                         Loading registered host records...
//                       </p>
//                     </td>
//                   </tr>
//                 ) : filteredHosts.length === 0 ? (
//                   <tr>
//                     <td colSpan="7" style={styles.emptyCell}>
//                       <FiUsers size={36} color={colors.muted} />
//                       <p style={{ marginTop: '8px', color: colors.muted, fontWeight: '600' }}>
//                         No host accounts found.
//                       </p>
//                     </td>
//                   </tr>
//                 ) : (
//                   filteredHosts.map((host) => {
//                     const isApproved = host.isApprove === 1;
//                     const isOtpVerified = host.verified === 1;
//                     const isProcessing = actionLoadingId === host.id;

//                     return (
//                       <tr key={host.id} style={styles.tableRow}>
//                         <td style={styles.tdId}>#{host.id}</td>

//                         {/* Name & Avatar */}
//                         <td style={styles.td}>
//                           <div style={styles.hostIdentity}>
//                             <div style={styles.tableAvatar}>
//                               {(host.name || 'H').charAt(0).toUpperCase()}
//                             </div>
//                             <div>
//                               <div style={styles.hostName}>{host.name || 'Anonymous Host'}</div>
//                               <div style={styles.hostEmail}>
//                                 <FiMail size={11} style={{ marginRight: '4px' }} />
//                                 {host.email}
//                               </div>
//                             </div>
//                           </div>
//                         </td>

//                         {/* Mobile */}
//                         <td style={styles.td}>
//                           <div style={styles.contactText}>
//                             <FiPhone size={12} color={colors.muted} style={{ marginRight: '6px' }} />
//                             {host.mobile || 'N/A'}
//                           </div>
//                         </td>

//                         {/* Date */}
//                         <td style={styles.td}>
//                           <span style={styles.dateText}>
//                             {new Date(host.created_at).toLocaleDateString('en-US', {
//                               month: 'short',
//                               day: 'numeric',
//                               year: 'numeric',
//                             })}
//                           </span>
//                         </td>

//                         {/* OTP Verification Chip */}
//                         <td style={styles.td}>
//                           <span
//                             style={{
//                               ...styles.badge,
//                               backgroundColor: isOtpVerified ? '#ecfdf5' : '#fff1f2',
//                               color: isOtpVerified ? colors.success : colors.danger,
//                               border: `1px solid ${isOtpVerified ? '#a7f3d0' : '#fecdd3'}`,
//                             }}
//                           >
//                             {isOtpVerified ? 'Verified' : 'Unverified'}
//                           </span>
//                         </td>
// {/* Trial / Plan Status Column */}
// <td style={styles.td}>
//   {(() => {
//     // 1. Check Paid Active Subscription (Silver, Gold, Basic)
//     const isPaidPlan = host.plan_tier && host.plan_tier !== 'trial';
//     const expiryDate = host.subscription_expires_at || host.trial_ends_at;

//     if (isPaidPlan && host.plan_status === 'active') {
//       const daysLeft = expiryDate 
//         ? Math.max(0, Math.ceil((new Date(expiryDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
//         : 30;

//       const planNameUpper = host.plan_tier.toUpperCase();
//       const planColor = host.plan_tier === 'gold' ? '#b45309' : host.plan_tier === 'silver' ? colors.orange : colors.blue;
//       const planBg = host.plan_tier === 'gold' ? '#fef3c7' : host.plan_tier === 'silver' ? '#fff7ed' : '#eff6ff';

//       return (
//         <div>
//           <span style={{
//             ...styles.badge,
//             backgroundColor: planBg,
//             color: planColor,
//             border: `1px solid ${planColor}40`
//           }}>
//             {planNameUpper} ({daysLeft}d left)
//           </span>
//           <div style={{ fontSize: '10px', color: colors.muted, marginTop: '3px' }}>
//             Quizzes: {host.used_event_quizzes || 0}/{host.allowed_event_quizzes || 0}
//           </div>
//         </div>
//       );
//     }

//     // 2. Check 24-Hour Trial Window
//     if (host.trial_ends_at) {
//       const timeLeftMs = new Date(host.trial_ends_at).getTime() - Date.now();
//       const hoursLeft = Math.max(0, Math.floor(timeLeftMs / (1000 * 60 * 60)));

//       if (timeLeftMs > 0) {
//         return (
//           <span style={{
//             ...styles.badge,
//             backgroundColor: '#fef3c7',
//             color: '#b45309',
//             border: '1px solid #fde68a'
//           }}>
//             {hoursLeft}h Trial Left
//           </span>
//         );
//       }
//       return (
//         <span style={{
//           ...styles.badge,
//           backgroundColor: '#fee2e2',
//           color: colors.danger,
//           border: '1px solid #fecdd3'
//         }}>
//           Trial Expired
//         </span>
//       );
//     }

//     // 3. Fallback when neither trial nor plan has been activated
//     return <span style={{ fontSize: '12px', color: colors.muted }}>Not Started</span>;
//   })()}
// </td>
//                         {/* Approval Status Chip */}
//                         <td style={styles.td}>
//                           <span
//                             style={{
//                               ...styles.badge,
//                               backgroundColor: isApproved ? '#eff6ff' : '#fff7ed',
//                               color: isApproved ? colors.blue : colors.orange,
//                               border: `1px solid ${isApproved ? '#bfdbfe' : '#fed7aa'}`,
//                             }}
//                           >
//                             {isApproved ? 'Approved' : 'Pending'}
//                           </span>
//                         </td>

//                         {/* Toggle Button */}
//                         <td style={{ ...styles.td, textAlign: 'center' }}>
//                           <button
//                             onClick={() => handleToggleApproval(host)}
//                             disabled={isProcessing}
//                             style={{
//                               ...styles.toggleBtn,
//                               backgroundColor: isApproved ? '#fee2e2' : colors.success,
//                               color: isApproved ? colors.danger : colors.white,
//                               cursor: isProcessing ? 'wait' : 'pointer',
//                             }}
//                           >
//                             {isProcessing ? (
//                               'Updating...'
//                             ) : isApproved ? (
//                               <>
//                                 <FiXCircle size={14} style={{ marginRight: '4px' }} />
//                                 Revoke
//                               </>
//                             ) : (
//                               <>
//                                 <FiCheckCircle size={14} style={{ marginRight: '4px' }} />
//                                 Approve
//                               </>
//                             )}
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//            </table>
//             </div>
//           )}
//           {/* TAB 2: PAYMENTS VERIFICATION TABLE */}
//           {activeTab === 'payments' && (
//             <div style={styles.tableContainer}>
//               <table style={styles.table}>
//                 <thead>
//                   <tr style={styles.tableHeadRow}>
//                     <th style={styles.th}>TXN ID</th>
//                     <th style={styles.th}>USER / CONTACT</th>
//                     <th style={styles.th}>PLAN &amp; CYCLE</th>
//                     <th style={styles.th}>AMOUNT</th>
//                     <th style={styles.th}>PAYMENT DATE</th>
//                     <th style={styles.th}>PROOF SCREENSHOT</th>
//                     <th style={styles.th}>STATUS</th>
//                     <th style={{ ...styles.th, textAlign: 'center' }}>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paymentsLoading ? (
//                     <tr>
//                       <td colSpan="8" style={styles.loadingCell}>
//                         <FiActivity size={24} color={colors.cyan} className="spin" />
//                         <p style={{ marginTop: '10px', color: colors.muted, fontSize: '13px' }}>
//                           Loading payment verification proofs...
//                         </p>
//                       </td>
//                     </tr>
//                   ) : filteredPayments.length === 0 ? (
//                     <tr>
//                       <td colSpan="8" style={styles.emptyCell}>
//                         <FiCreditCard size={36} color={colors.muted} />
//                         <p style={{ marginTop: '8px', color: colors.muted, fontWeight: '600' }}>
//                           No payment requests found.
//                         </p>
//                       </td>
//                     </tr>
//                   ) : (
//                     filteredPayments.map((p) => {
//                       const isPending = p.status === 'pending';
//                       const isApproved = p.status === 'approved';
//                       const isProcessing = approvingPaymentId === p.id;

//                       return (
//                         <tr key={p.id} style={styles.tableRow}>
//                           <td style={styles.tdId}>
//                             <span style={{ fontFamily: 'monospace', fontWeight: '800', color: colors.blue }}>
//                               {p.transaction_id}
//                             </span>
//                           </td>

//                           {/* User Identity */}
//                           <td style={styles.td}>
//                             <div style={styles.hostName}>{p.full_name}</div>
//                             <div style={styles.hostEmail}>
//                               <FiMail size={11} style={{ marginRight: '4px' }} /> {p.email}
//                             </div>
//                             <div style={{ fontSize: '11px', color: colors.muted, marginTop: '2px' }}>
//                               <FiPhone size={10} style={{ marginRight: '4px' }} /> {p.mobile}
//                             </div>
//                           </td>

//                           {/* Plan */}
//                           <td style={styles.td}>
//                             <span style={{ 
//                               fontWeight: '800', 
//                               color: p.plan_name === 'Gold' ? '#d97706' : p.plan_name === 'Silver' ? colors.orange : colors.blue 
//                             }}>
//                               {p.plan_name}
//                             </span>
//                             <span style={{ display: 'block', fontSize: '11px', color: colors.muted, textTransform: 'capitalize' }}>
//                               {p.billing_cycle} Cycle
//                             </span>
//                           </td>

//                           {/* Amount */}
//                           <td style={styles.td}>
//                             <strong style={{ fontSize: '15px', color: colors.textMain }}>
//                               ₹{Number(p.amount).toLocaleString()}
//                             </strong>
//                           </td>

//                           {/* Payment Date */}
//                           <td style={styles.td}>
//                             <span style={styles.dateText}>
//                               {new Date(p.payment_date).toLocaleDateString('en-US', {
//                                 month: 'short',
//                                 day: 'numeric',
//                                 year: 'numeric'
//                               })}
//                             </span>
//                           </td>

//                           {/* Screenshot Proof Preview Button */}
//                           <td style={styles.td}>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                               <img 
//                                 src={p.screenshot_url} 
//                                 alt="Proof" 
//                                 style={{ width: '42px', height: '42px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0', cursor: 'pointer' }}
//                                 onClick={() => setPreviewImage(p.screenshot_url)}
//                               />
//                               <button
//                                 type="button"
//                                 onClick={() => setPreviewImage(p.screenshot_url)}
//                                 style={{ background: 'none', border: 'none', color: colors.blue, cursor: 'pointer', padding: 0 }}
//                                 title="Zoom Screenshot"
//                               >
//                                 <FiEye size={16} />
//                               </button>
//                             </div>
//                           </td>

//                           {/* Status */}
//                           <td style={styles.td}>
//                             <span style={{
//                               ...styles.badge,
//                               backgroundColor: isApproved ? '#ecfdf5' : isPending ? '#fff7ed' : '#fee2e2',
//                               color: isApproved ? colors.success : isPending ? colors.orange : colors.danger,
//                               border: `1px solid ${isApproved ? '#a7f3d0' : isPending ? '#fed7aa' : '#fecdd3'}`
//                             }}>
//                               {p.status.toUpperCase()}
//                             </span>
//                           </td>

//                           {/* Action Buttons */}
//                           <td style={{ ...styles.td, textAlign: 'center' }}>
//                             {isPending ? (
//                               <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
//                                 <button
//                                   onClick={() => handlePaymentAction(p.id, 'approved')}
//                                   disabled={isProcessing}
//                                   style={{
//                                     ...styles.toggleBtn,
//                                     backgroundColor: colors.success,
//                                     color: colors.white
//                                   }}
//                                 >
//                                   {isProcessing ? 'Verifying...' : 'Approve & Activate'}
//                                 </button>
//                                 <button
//                                   onClick={() => handlePaymentAction(p.id, 'rejected')}
//                                   disabled={isProcessing}
//                                   style={{
//                                     ...styles.toggleBtn,
//                                     backgroundColor: '#fee2e2',
//                                     color: colors.danger
//                                   }}
//                                 >
//                                   Reject
//                                 </button>
//                               </div>
//                             ) : (
//                               <span style={{ fontSize: '12px', color: colors.muted, fontWeight: '700' }}>
//                                 {isApproved ? '✓ Activated' : '✕ Rejected'}
//                               </span>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//           </div>
//         </div>
//       </main>
//       {/* SCREENSHOT PROOF ZOOM MODAL */}
//       {previewImage && (
//         <div 
//           style={{
//             position: 'fixed',
//             inset: 0,
//             backgroundColor: 'rgba(11, 12, 38, 0.85)',
//             backdropFilter: 'blur(8px)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 99999,
//             padding: '20px'
//           }}
//           onClick={() => setPreviewImage(null)}
//         >
//           <div 
//             style={{
//               backgroundColor: '#ffffff',
//               borderRadius: '20px',
//               maxWidth: '650px',
//               width: '100%',
//               padding: '20px',
//               textAlign: 'center',
//               boxShadow: '0 25px 60px rgba(0,0,0,0.4)',
//               position: 'relative'
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
//               <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: colors.blue }}>
//                 Payment Screenshot Verification
//               </h4>
//               <button 
//                 onClick={() => setPreviewImage(null)}
//                 style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: colors.muted }}
//               >
//                 ✕
//               </button>
//             </div>

//             <img 
//               src={previewImage} 
//               alt="Full Receipt" 
//               style={{ width: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: '12px', border: '1px solid #e2e8f0' }} 
//             />

//             <div style={{ marginTop: '14px' }}>
//               <a 
//                 href={previewImage} 
//                 target="_blank" 
//                 rel="noreferrer" 
//                 style={{ color: colors.orange, fontSize: '13px', fontWeight: '700', textDecoration: 'none' }}
//               >
//                 Open in Full Window &rarr;
//               </a>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   dashboardWrapper: {
//     minHeight: '100vh',
//     backgroundColor: colors.bgLight,
//     fontFamily: '"Plus Jakarta Sans", sans-serif',
//     color: colors.textMain,
//   },
//   header: {
//     backgroundColor: colors.deepNavy,
//     borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
//     position: 'sticky',
//     top: 0,
//     zIndex: 100,
//   },
//   headerInner: {
//     maxWidth: '1280px',
//     margin: '0 auto',
//     padding: '14px 24px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//   },
//   brandRow: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//   },
//   logoBadge: {
//     width: '38px',
//     height: '38px',
//     borderRadius: '10px',
//     backgroundColor: 'rgba(99, 222, 204, 0.15)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   brandTitle: {
//     fontSize: '20px',
//     fontWeight: '900',
//     color: colors.white,
//     margin: 0,
//     letterSpacing: '-0.5px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//   },
//   adminBadge: {
//     fontSize: '10px',
//     fontWeight: '800',
//     letterSpacing: '1px',
//     backgroundColor: 'rgba(243, 80, 24, 0.2)',
//     color: colors.orange,
//     padding: '2px 8px',
//     borderRadius: '6px',
//     border: '1px solid rgba(243, 80, 24, 0.3)',
//   },
//   profileSection: {
//     position: 'relative',
//   },
//   profileBtn: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     background: 'rgba(255, 255, 255, 0.05)',
//     border: '1px solid rgba(255, 255, 255, 0.1)',
//     borderRadius: '12px',
//     padding: '6px 12px',
//     cursor: 'pointer',
//     color: colors.white,
//   },
//   avatar: {
//     width: '34px',
//     height: '34px',
//     borderRadius: '8px',
//     backgroundColor: colors.blue,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   profileMeta: {
//     textAlign: 'left',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   profileRole: {
//     fontSize: '9px',
//     fontWeight: '800',
//     color: colors.cyan,
//     letterSpacing: '0.8px',
//   },
//   profileEmail: {
//     fontSize: '12px',
//     fontWeight: '600',
//     color: 'rgba(255, 255, 255, 0.85)',
//   },
//   dropdownMenu: {
//     position: 'absolute',
//     right: 0,
//     top: '52px',
//     width: '210px',
//     backgroundColor: colors.white,
//     borderRadius: '14px',
//     boxShadow: '0 12px 30px rgba(15, 17, 55, 0.15)',
//     border: `1px solid ${colors.border}`,
//     padding: '10px',
//     zIndex: 200,
//   },
//   dropdownHeader: {
//     padding: '8px 10px',
//   },
//   dropdownLabel: {
//     fontSize: '11px',
//     color: colors.muted,
//     margin: 0,
//   },
//   dropdownUserEmail: {
//     fontSize: '13px',
//     fontWeight: '700',
//     color: colors.textMain,
//     margin: '2px 0 0 0',
//   },
//   divider: {
//     height: '1px',
//     backgroundColor: colors.border,
//     margin: '6px 0',
//   },
//   logoutBtn: {
//     width: '120px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '10px',
//     backgroundColor: '#fff1f2',
//     border: 'none',
//     borderRadius: '8px',
//     color: colors.danger,
//     fontSize: '13px',
//     fontWeight: '700',
//     cursor: 'pointer',
//     transition: 'background-color 0.2s',
//   },
//   mainContainer: {
//     maxWidth: '1280px',
//     margin: '0 auto',
//     padding: '28px 24px 60px 24px',
//   },
//   kpiGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
//     gap: '16px',
//     marginBottom: '24px',
//   },
//   kpiCard: {
//     backgroundColor: colors.white,
//     borderRadius: '18px',
//     padding: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '16px',
//     border: `1px solid ${colors.border}`,
//     boxShadow: '0 4px 12px rgba(15, 17, 55, 0.03)',
//   },
//   kpiIconWrap: (color) => ({
//     width: '48px',
//     height: '48px',
//     borderRadius: '14px',
//     backgroundColor: `${color}15`,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   }),
//   kpiLabel: {
//     fontSize: '11px',
//     fontWeight: '800',
//     letterSpacing: '0.8px',
//     color: colors.muted,
//     margin: '0 0 4px 0',
//   },
//   kpiValue: {
//     fontSize: '26px',
//     fontWeight: '900',
//     color: colors.textMain,
//     margin: 0,
//   },
//   tableCard: {
//     backgroundColor: colors.white,
//     borderRadius: '20px',
//     border: `1px solid ${colors.border}`,
//     boxShadow: '0 6px 20px rgba(15, 17, 55, 0.04)',
//     overflow: 'hidden',
//   },
//   tableControlRow: {
//     padding: '22px 24px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     gap: '16px',
//     borderBottom: `1px solid ${colors.border}`,
//   },
//   cardHeading: {
//     fontSize: '18px',
//     fontWeight: '800',
//     color: colors.textMain,
//     margin: '0 0 4px 0',
//   },
//   cardSub: {
//     fontSize: '13px',
//     color: colors.muted,
//     margin: 0,
//   },
//   actionControls: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//   },
//   searchBox: {
//     display: 'flex',
//     alignItems: 'center',
//     backgroundColor: colors.bgLight,
//     border: `1.5px solid ${colors.border}`,
//     borderRadius: '10px',
//     padding: '0 12px',
//     height: '40px',
//     width: '260px',
//   },
//   searchInput: {
//     border: 'none',
//     outline: 'none',
//     backgroundColor: 'transparent',
//     fontSize: '13px',
//     color: colors.textMain,
//     width: '100%',
//   },
//   refreshBtn: {
//     width: '40px',
//     height: '40px',
//     borderRadius: '10px',
//     backgroundColor: colors.bgLight,
//     border: `1.5px solid ${colors.border}`,
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     cursor: 'pointer',
//   },
//   tableContainer: {
//     width: '100%',
//     overflowX: 'auto',
//   },
//   table: {
//     width: '100%',
//     borderCollapse: 'collapse',
//     textAlign: 'left',
//   },
//   tableHeadRow: {
//     backgroundColor: '#fafbfc',
//     borderBottom: `1px solid ${colors.border}`,
//   },
//   th: {
//     padding: '12px 18px',
//     fontSize: '11px',
//     fontWeight: '800',
//     letterSpacing: '0.6px',
//     color: colors.muted,
//     textTransform: 'uppercase',
//   },
//   tableRow: {
//     borderBottom: `1px solid ${colors.border}`,
//     transition: 'background-color 0.15s ease',
//   },
//   tdId: {
//     padding: '14px 18px',
//     fontSize: '12px',
//     fontWeight: '800',
//     color: colors.muted,
//   },
//   td: {
//     padding: '14px 18px',
//     fontSize: '13px',
//     verticalAlign: 'middle',
//   },
//   hostIdentity: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//   },
//   tableAvatar: {
//     width: '34px',
//     height: '34px',
//     borderRadius: '10px',
//     backgroundColor: 'rgba(47, 49, 148, 0.08)',
//     color: colors.blue,
//     fontWeight: '800',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '14px',
//   },
//   hostName: {
//     fontWeight: '700',
//     color: colors.textMain,
//     fontSize: '14px',
//   },
//   hostEmail: {
//     fontSize: '12px',
//     color: colors.muted,
//     display: 'flex',
//     alignItems: 'center',
//     marginTop: '2px',
//   },
//   contactText: {
//     display: 'flex',
//     alignItems: 'center',
//     fontSize: '13px',
//     color: colors.textMain,
//     fontWeight: '600',
//   },
//   dateText: {
//     fontSize: '12px',
//     color: colors.muted,
//     fontWeight: '600',
//   },
//   badge: {
//     display: 'inline-block',
//     padding: '4px 10px',
//     borderRadius: '20px',
//     fontSize: '11px',
//     fontWeight: '800',
//     letterSpacing: '0.4px',
//   },
//   toggleBtn: {
//     border: 'none',
//     borderRadius: '8px',
//     padding: '6px 14px',
//     fontSize: '12px',
//     fontWeight: '800',
//     display: 'inline-flex',
//     alignItems: 'center',
//     transition: 'all 0.2s',
//   },
//   loadingCell: {
//     padding: '50px 0',
//     textAlign: 'center',
//   },
//   emptyCell: {
//     padding: '50px 0',
//     textAlign: 'center',
//   },
// };



import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
  FiUsers, 
  FiCheckCircle, 
  FiXCircle, 
  FiSearch, 
  FiLogOut, 
  FiRefreshCw, 
  FiChevronDown, 
  FiMail, 
  FiPhone, 
  FiCreditCard,
  FiEye,
  FiBarChart2,
  FiMenu,
  FiX,
  FiLayers,
  FiClock
} from 'react-icons/fi';
import { RiAdminLine, RiDashboardLine, RiShareForwardLine } from 'react-icons/ri';
import HostAnalyticsTab from './HostAnalyticsTab';
import ReferralsTab from './ReferralsTab';

const colors = {
  orange: '#f35018',
  blue: '#2f3194',
  deepNavy: '#0b0c26',
  surfaceDark: '#16183e',
  cyan: '#63decc',
  white: '#ffffff',
  textMain: '#0f1137',
  bgLight: '#f4f6fc',
  muted: '#64748b',
  border: '#e2e8f0',
  success: '#10b981',
  danger: '#ef4444',
  gold: '#fbbf24',
};

const BASE_URL = 'https://rvapi.emedha.in/auth/api';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  // Active Main Navigation Menu: 'dashboard' | 'host_analytics'
  const [activeMenu, setActiveMenu] = useState('dashboard');

  // Overview / Hosts Tab Sub-filter
  const [activeTab, setActiveTab] = useState('hosts'); // 'hosts' | 'payments'
  
  // Data States
  const [hosts, setHosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [actionLoadingId, setActionLoadingId] = useState(null);

  // Payment Verification States
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [approvingPaymentId, setApprovingPaymentId] = useState(null);

  // Deep Analytics Data State
  const [intelligenceData, setIntelligenceData] = useState(null);
  const [loadingIntelligence, setLoadingIntelligence] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('admin_user');
    if (!stored) {
      navigate('/admin-login');
      return;
    }
    setAdminUser(JSON.parse(stored));
    fetchHosts();
    fetchPayments();
    fetchIntelligence();
    fetchReferrals();

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [navigate]);

  const fetchHosts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/admin/hosts`).catch(() => axios.get(`${BASE_URL}/admin/hosts`));
      if (res.data?.success && Array.isArray(res.data.hosts)) {
        setHosts(res.data.hosts);
      }
    } catch (err) {
      console.error('Failed to load hosts:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPayments = async () => {
    try {
      setPaymentsLoading(true);
      const res = await axios.get(`${BASE_URL}/api/admin/payment-requests`).catch(() => axios.get(`${BASE_URL}/admin/payment-requests`));
      if (res.data?.success && Array.isArray(res.data.payments)) {
        setPaymentRequests(res.data.payments);
      }
    } catch (err) {
      console.error('Failed to load payment requests:', err);
    } finally {
      setPaymentsLoading(false);
    }
  };

  const fetchIntelligence = async () => {
    try {
      setLoadingIntelligence(true);
      const res = await axios.get(`${BASE_URL}/api/admin/host-intelligence`).catch(() => axios.get(`${BASE_URL}/admin/host-intelligence`));
      if (res.data?.success) {
        setIntelligenceData(res.data.data);
      }
    } catch (err) {
      console.error('Failed to fetch intelligence report:', err);
    } finally {
      setLoadingIntelligence(false);
    }
  };


  const [referrals, setReferrals] = useState([]);
const [referralsLoading, setReferralsLoading] = useState(false);

const fetchReferrals = async () => {
  try {
    setReferralsLoading(true);
    const res = await axios.get(`${BASE_URL}/api/admin/referrals`).catch(() => axios.get(`${BASE_URL}/admin/referrals`));
    if (res.data?.success && Array.isArray(res.data.referrals)) {
      setReferrals(res.data.referrals);
    }
  } catch (err) {
    console.error('Failed to load referrals:', err);
  } finally {
    setReferralsLoading(false);
  }
};

  const handleToggleApproval = async (host) => {
    try {
      setActionLoadingId(host.id);
      const res = await axios.post(`${BASE_URL}/api/admin/toggle-approval`, {
        hostId: host.id,
        currentStatus: host.isApprove,
        email: host.email,
        name: host.name,
      });

      if (res.data?.success) {
        setHosts((prev) =>
          prev.map((h) => (h.id === host.id ? { ...h, isApprove: res.data.newStatus } : h))
        );
        fetchIntelligence();
      }
    } catch (err) {
      alert('Failed to update host approval status.');
    } finally {
      setActionLoadingId(null);
    }
  };

  const handlePaymentAction = async (paymentId, action) => {
    const confirmMsg = action === 'approved' 
      ? 'Verify and activate this subscription for 30 days?' 
      : 'Reject this payment verification proof?';
    if (!window.confirm(confirmMsg)) return;

    try {
      setApprovingPaymentId(paymentId);
      const res = await axios.post(`${BASE_URL}/api/admin/approve-payment`, { paymentId, action });
      if (res.data?.success) {
        alert(res.data.message || 'Payment updated successfully!');
        setPaymentRequests((prev) => prev.map((p) => p.id === paymentId ? { ...p, status: action } : p));
        fetchHosts();
        fetchIntelligence();
      }
    } catch (err) {
      alert('Failed to update payment status.');
    } finally {
      setApprovingPaymentId(null);
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('admin_user');
    navigate('/admin-login');
  };

  const filteredHosts = hosts.filter((h) => {
    const q = searchQuery.toLowerCase();
    return (
      (h.name && h.name.toLowerCase().includes(q)) ||
      (h.email && h.email.toLowerCase().includes(q)) ||
      (h.mobile && h.mobile.includes(q))
    );
  });

  const filteredPayments = paymentRequests.filter((p) => {
    const q = searchQuery.toLowerCase();
    return (
      (p.full_name && p.full_name.toLowerCase().includes(q)) ||
      (p.email && p.email.toLowerCase().includes(q)) ||
      (p.transaction_id && p.transaction_id.toLowerCase().includes(q)) ||
      (p.plan_name && p.plan_name.toLowerCase().includes(q))
    );
  });

  const approvedCount = hosts.filter((h) => h.isApprove === 1).length;
  const pendingCount = hosts.length - approvedCount;
  const pendingPaymentsCount = paymentRequests.filter((p) => p.status === 'pending').length;

  return (
    <div style={styles.shell}>
      
      {/* MOBILE BACKDROP DRAWER */}
      {isMobileSidebarOpen && (
        <div style={styles.mobileBackdrop} onClick={() => setIsMobileSidebarOpen(false)} />
      )}

      {/* 1. RESPONSIVE SIDEBAR */}
      <aside style={{
        ...styles.sidebar,
        transform: isMobileSidebarOpen ? 'translateX(0)' : undefined
      }}>
        <div style={styles.sidebarBrand}>
          <div style={styles.brandBadge}>
            <RiDashboardLine size={20} color={colors.cyan} />
          </div>
          <div>
            <h2 style={styles.brandText}>
              Quizify<span style={{ color: colors.orange }}>AI</span>
            </h2>
            <span style={styles.sidebarBadge}>EXECUTIVE ADMIN</span>
          </div>
        </div>

        <nav style={styles.navigationMenu}>
          <span style={styles.menuGroupHeading}>CORE WORKSPACE</span>

          <button 
            style={{
              ...styles.navButton,
              backgroundColor: activeMenu === 'dashboard' ? 'rgba(99, 222, 204, 0.12)' : 'transparent',
              color: activeMenu === 'dashboard' ? colors.cyan : '#cbd5e1',
              fontWeight: activeMenu === 'dashboard' ? '800' : '600'
            }}
            onClick={() => {
              setActiveMenu('dashboard');
              setIsMobileSidebarOpen(false);
            }}
          >
            <RiDashboardLine size={18} />
            <span>Dashboard Overview</span>
          </button>

          <button 
            style={{
              ...styles.navButton,
              backgroundColor: activeMenu === 'host_analytics' ? 'rgba(99, 222, 204, 0.12)' : 'transparent',
              color: activeMenu === 'host_analytics' ? colors.cyan : '#cbd5e1',
              fontWeight: activeMenu === 'host_analytics' ? '800' : '600'
            }}
            onClick={() => {
              setActiveMenu('host_analytics');
              setIsMobileSidebarOpen(false);
            }}
          >
            <FiBarChart2 size={18} />
            <span>Host &amp; Quiz Analytics</span>
          </button>

          <button 
  style={{
    ...styles.navButton,
    backgroundColor: activeMenu === 'referrals' ? 'rgba(99, 222, 204, 0.12)' : 'transparent',
    color: activeMenu === 'referrals' ? colors.cyan : '#cbd5e1',
    fontWeight: activeMenu === 'referrals' ? '800' : '600'
  }}
  onClick={() => {
    setActiveMenu('referrals');
    setIsMobileSidebarOpen(false);
  }}
>
  <RiShareForwardLine size={18} />
  <span>Member Referrals</span>
  {referrals.length > 0 && (
    <span style={{ ...styles.pendingIndicator, backgroundColor: 'rgba(99, 222, 204, 0.2)', color: colors.cyan }}>
      {referrals.length}
    </span>
  )}
</button>

          <span style={{ ...styles.menuGroupHeading, marginTop: '20px' }}>ACCOUNT VERIFICATIONS</span>

          <button 
            style={{
              ...styles.navButton,
              backgroundColor: (activeMenu === 'dashboard' && activeTab === 'payments') ? 'rgba(243, 80, 24, 0.15)' : 'transparent',
              color: (activeMenu === 'dashboard' && activeTab === 'payments') ? colors.orange : '#cbd5e1'
            }}
            onClick={() => {
              setActiveMenu('dashboard');
              setActiveTab('payments');
              setIsMobileSidebarOpen(false);
            }}
          >
            <FiCreditCard size={18} />
            <span>Payment Proofs</span>
            {pendingPaymentsCount > 0 && (
              <span style={styles.pendingIndicator}>{pendingPaymentsCount}</span>
            )}
          </button>
        </nav>

        {/* Sidebar Footer */}
        <div style={styles.sidebarFooter}>
          <button onClick={handleLogout} style={styles.sidebarLogoutBtn}>
            <FiLogOut size={16} color={colors.danger} />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>

      {/* 2. MAIN WORKSPACE AREA */}
      <div style={styles.mainShell}>
        
        {/* TOP EXECUTIVE BAR */}
        <header style={styles.topBar}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <button 
              style={styles.mobileHamburger}
              onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
            >
              {isMobileSidebarOpen ? <FiX size={20} /> : <FiMenu size={20} />}
            </button>
            <h2 style={styles.activeMenuHeading}>
             {activeMenu === 'dashboard' 
  ? 'Control Center & Approvals' 
  : activeMenu === 'referrals' 
  ? 'Referrals & Member Growth' 
  : 'Host & Quiz Intelligence Engine'}
            </h2>
          </div>

          {/* User Profile Pill */}
          <div style={{ position: 'relative' }} ref={dropdownRef}>
            <button 
              onClick={() => setIsDropdownOpen(!isDropdownOpen)} 
              style={styles.userProfilePill}
            >
              <div style={styles.avatar}>
                <RiAdminLine size={16} color={colors.white} />
              </div>
              <div style={styles.profileTextWrap}>
                <span style={styles.profileRoleText}>SUPER ADMIN</span>
                <span style={styles.profileEmailText}>{adminUser?.email || 'admin@quizifyai.in'}</span>
              </div>
              <FiChevronDown size={14} color={colors.muted} />
            </button>

            {isDropdownOpen && (
              <div style={styles.profileDropdown}>
                <div style={{ padding: '8px 12px' }}>
                  <span style={{ fontSize: '11px', color: colors.muted }}>Authorized System User</span>
                  <strong style={{ display: 'block', fontSize: '13px', color: colors.textMain }}>{adminUser?.email}</strong>
                </div>
                <div style={styles.divider} />
                <button onClick={handleLogout} style={styles.dropdownLogout}>
                  <FiLogOut size={14} color={colors.danger} />
                  <span>Log Out</span>
                </button>
              </div>
            )}
          </div>
        </header>

        {/* VIEW ROUTING CONTENT CONTAINER */}
        <main style={styles.contentWrap}>
          
          {/* VIEW A: HOST & QUIZ INTELLIGENCE (NEW WORKSPACE) */}
          {activeMenu === 'host_analytics' && (
            <HostAnalyticsTab 
              intelligenceData={intelligenceData} 
              loading={loadingIntelligence} 
              onRefresh={fetchIntelligence} 
            />
          )}


          {/* VIEW C: REFERRALS MANAGEMENT */}
{activeMenu === 'referrals' && (
  <ReferralsTab 
    referrals={referrals} 
    loading={referralsLoading} 
    onRefresh={fetchReferrals} 
  />
)}

          {/* VIEW B: DEFAULT DASHBOARD (HOSTS & PAYMENTS VERIFICATIONS) */}
          {activeMenu === 'dashboard' && (
            <div>
              {/* TOP SUMMARY KPI TILES */}
              <div style={styles.kpiGrid}>
                <div style={styles.kpiCard}>
                  <div style={styles.kpiIconWrap(colors.blue)}>
                    <FiUsers size={22} color={colors.blue} />
                  </div>
                  <div>
                    <p style={styles.kpiLabel}>TOTAL REGISTERED HOSTS</p>
                    <h3 style={styles.kpiValue}>{hosts.length}</h3>
                  </div>
                </div>

                <div style={styles.kpiCard}>
                  <div style={styles.kpiIconWrap(colors.success)}>
                    <FiCheckCircle size={22} color={colors.success} />
                  </div>
                  <div>
                    <p style={styles.kpiLabel}>APPROVED HOSTS</p>
                    <h3 style={{ ...styles.kpiValue, color: colors.success }}>{approvedCount}</h3>
                  </div>
                </div>

                <div style={styles.kpiCard}>
                  <div style={styles.kpiIconWrap(colors.orange)}>
                    <FiClock size={22} color={colors.orange} />
                  </div>
                  <div>
                    <p style={styles.kpiLabel}>PENDING APPROVALS</p>
                    <h3 style={{ ...styles.kpiValue, color: colors.orange }}>{pendingCount}</h3>
                  </div>
                </div>

                <div 
                  style={{ ...styles.kpiCard, cursor: 'pointer', border: activeTab === 'payments' ? `2px solid ${colors.blue}` : `1px solid ${colors.border}` }}
                  onClick={() => setActiveTab('payments')}
                >
                  <div style={styles.kpiIconWrap(colors.gold)}>
                    <FiCreditCard size={22} color="#b45309" />
                  </div>
                  <div>
                    <p style={styles.kpiLabel}>PENDING PAYMENTS</p>
                    <h3 style={{ ...styles.kpiValue, color: '#b45309' }}>{pendingPaymentsCount}</h3>
                  </div>
                </div>
              </div>

              {/* TAB SELECTOR */}
              <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <button
                  onClick={() => setActiveTab('hosts')}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '700',
                    fontSize: '13px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    backgroundColor: activeTab === 'hosts' ? colors.blue : colors.white,
                    color: activeTab === 'hosts' ? colors.white : colors.muted,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}
                >
                  <FiUsers size={16} /> Host Accounts ({hosts.length})
                </button>

                <button
                  onClick={() => setActiveTab('payments')}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '12px',
                    border: 'none',
                    fontWeight: '700',
                    fontSize: '13px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    backgroundColor: activeTab === 'payments' ? colors.blue : colors.white,
                    color: activeTab === 'payments' ? colors.white : colors.muted,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}
                >
                  <FiCreditCard size={16} /> Payment Verifications
                  {pendingPaymentsCount > 0 && (
                    <span style={styles.newAlertBadge}>{pendingPaymentsCount} NEW</span>
                  )}
                </button>
              </div>

              {/* TABLE CONTAINER CARD */}
              <div style={styles.tableCard}>
                <div style={styles.tableControlRow}>
                  <div>
                    <h3 style={styles.cardHeading}>
                      {activeTab === 'hosts' ? 'Host Accounts Management' : 'Payment Verification Requests'}
                    </h3>
                    <p style={styles.cardSub}>
                      {activeTab === 'hosts' 
                        ? 'Review registered hosts, verify OTP states, and toggle match deployment authorization.' 
                        : 'Review UPI payment proofs, inspect transaction UTRs, and activate 30-day subscription quotas.'}
                    </p>
                  </div>

                  <div style={styles.actionControls}>
                    <div style={styles.searchBox}>
                      <FiSearch size={16} color={colors.muted} style={{ marginRight: '8px' }} />
                      <input
                        type="text"
                        placeholder={activeTab === 'hosts' ? "Search name, email, mobile..." : "Search name, UTR, plan..."}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={styles.searchInput}
                      />
                    </div>

                    <button onClick={activeTab === 'hosts' ? fetchHosts : fetchPayments} style={styles.refreshBtn} title="Refresh Table">
                      <FiRefreshCw size={16} color={colors.blue} className={(loading || paymentsLoading) ? 'spin' : ''} />
                    </button>
                  </div>
                </div>

                {/* HOSTS TABLE */}
                {activeTab === 'hosts' && (
                  <div style={styles.tableContainer}>
                    <table style={styles.table}>
                      <thead>
                        <tr style={styles.tableHeadRow}>
                          <th style={styles.th}>ID</th>
                          <th style={styles.th}>HOST IDENTITY</th>
                          <th style={styles.th}>CONTACT</th>
                          <th style={styles.th}>REGISTRATION DATE</th>
                          <th style={styles.th}>OTP VERIFIED</th>
                          <th style={styles.th}>TRIAL / PLAN STATUS</th>
                          <th style={styles.th}>APPROVAL STATUS</th>
                          <th style={{ ...styles.th, textAlign: 'center' }}>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredHosts.map((host) => {
                          const isApproved = host.isApprove === 1;
                          const isOtpVerified = host.verified === 1;
                          const isProcessing = actionLoadingId === host.id;

                          return (
                            <tr key={host.id} style={styles.tableRow}>
                              <td style={styles.tdId}>#{host.id}</td>
                              <td style={styles.td}>
                                <div style={styles.hostIdentity}>
                                  <div style={styles.tableAvatar}>
                                    {(host.name || 'H').charAt(0).toUpperCase()}
                                  </div>
                                  <div>
                                    <div style={styles.hostName}>{host.name}</div>
                                    <div style={styles.hostEmail}>
                                      <FiMail size={11} style={{ marginRight: '4px' }} />
                                      {host.email}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td style={styles.td}>{host.mobile || 'N/A'}</td>
                              <td style={styles.td}>{new Date(host.created_at).toLocaleDateString()}</td>
                              <td style={styles.td}>
                                <span style={{
                                  ...styles.badge,
                                  backgroundColor: isOtpVerified ? '#ecfdf5' : '#fff1f2',
                                  color: isOtpVerified ? colors.success : colors.danger,
                                  border: `1px solid ${isOtpVerified ? '#a7f3d0' : '#fecdd3'}`
                                }}>
                                  {isOtpVerified ? 'Verified' : 'Unverified'}
                                </span>
                              </td>
                              <td style={styles.td}>
                                <span style={{
                                  ...styles.badge,
                                  backgroundColor: host.plan_tier === 'gold' ? '#fef3c7' : host.plan_tier === 'silver' ? '#fff7ed' : '#eff6ff',
                                  color: host.plan_tier === 'gold' ? '#b45309' : host.plan_tier === 'silver' ? colors.orange : colors.blue
                                }}>
                                  {(host.plan_tier || 'trial').toUpperCase()}
                                </span>
                              </td>
                              <td style={styles.td}>
                                <span style={{
                                  ...styles.badge,
                                  backgroundColor: isApproved ? '#eff6ff' : '#fff7ed',
                                  color: isApproved ? colors.blue : colors.orange
                                }}>
                                  {isApproved ? 'Approved' : 'Pending'}
                                </span>
                              </td>
                              <td style={{ ...styles.td, textAlign: 'center' }}>
                                <button
                                  onClick={() => handleToggleApproval(host)}
                                  disabled={isProcessing}
                                  style={{
                                    ...styles.toggleBtn,
                                    backgroundColor: isApproved ? '#fee2e2' : colors.success,
                                    color: isApproved ? colors.danger : colors.white,
                                    cursor: isProcessing ? 'wait' : 'pointer'
                                  }}
                                >
                                  {isProcessing ? 'Updating...' : isApproved ? 'Revoke' : 'Approve'}
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* PAYMENTS TABLE */}
                {activeTab === 'payments' && (
                  <div style={styles.tableContainer}>
                    <table style={styles.table}>
                      <thead>
                        <tr style={styles.tableHeadRow}>
                          <th style={styles.th}>TXN ID</th>
                          <th style={styles.th}>USER / CONTACT</th>
                          <th style={styles.th}>PLAN &amp; CYCLE</th>
                          <th style={styles.th}>AMOUNT</th>
                          <th style={styles.th}>PAYMENT DATE</th>
                          <th style={styles.th}>PROOF</th>
                          <th style={styles.th}>STATUS</th>
                          <th style={{ ...styles.th, textAlign: 'center' }}>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredPayments.map((p) => {
                          const isPending = p.status === 'pending';
                          const isApproved = p.status === 'approved';
                          const isProcessing = approvingPaymentId === p.id;

                          return (
                            <tr key={p.id} style={styles.tableRow}>
                              <td style={styles.tdId}>{p.transaction_id}</td>
                              <td style={styles.td}>
                                <strong>{p.full_name}</strong>
                                <span style={{ display: 'block', fontSize: '11px', color: colors.muted }}>{p.email}</span>
                              </td>
                              <td style={styles.td}>
                                <strong>{p.plan_name}</strong>
                                <span style={{ display: 'block', fontSize: '11px', color: colors.muted }}>{p.billing_cycle}</span>
                              </td>
                              <td style={styles.td}><strong>₹{Number(p.amount).toLocaleString()}</strong></td>
                              <td style={styles.td}>{new Date(p.payment_date).toLocaleDateString()}</td>
                              <td style={styles.td}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                  <img 
                                    src={p.screenshot_url} 
                                    alt="Proof" 
                                    style={{ width: '38px', height: '38px', objectFit: 'cover', borderRadius: '6px', cursor: 'pointer' }}
                                    onClick={() => setPreviewImage(p.screenshot_url)}
                                  />
                                  <button onClick={() => setPreviewImage(p.screenshot_url)} style={{ border: 'none', background: 'none', cursor: 'pointer', color: colors.blue }}>
                                    <FiEye size={16} />
                                  </button>
                                </div>
                              </td>
                              <td style={styles.td}>
                                <span style={{
                                  ...styles.badge,
                                  backgroundColor: isApproved ? '#ecfdf5' : isPending ? '#fff7ed' : '#fee2e2',
                                  color: isApproved ? colors.success : isPending ? colors.orange : colors.danger
                                }}>
                                  {p.status.toUpperCase()}
                                </span>
                              </td>
                              <td style={{ ...styles.td, textAlign: 'center' }}>
                                {isPending ? (
                                  <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                    <button 
                                      onClick={() => handlePaymentAction(p.id, 'approved')}
                                      style={{ ...styles.toggleBtn, backgroundColor: colors.success, color: colors.white }}
                                    >
                                      Approve
                                    </button>
                                    <button 
                                      onClick={() => handlePaymentAction(p.id, 'rejected')}
                                      style={{ ...styles.toggleBtn, backgroundColor: '#fee2e2', color: colors.danger }}
                                    >
                                      Reject
                                    </button>
                                  </div>
                                ) : (
                                  <span style={{ fontSize: '12px', fontWeight: '800', color: colors.muted }}>
                                    {isApproved ? '✓ Verified' : '✕ Rejected'}
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

        </main>
      </div>

      {/* ZOOM IMAGE MODAL */}
      {previewImage && (
        <div style={styles.modalBackdrop} onClick={() => setPreviewImage(null)}>
          <div style={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <h4 style={{ margin: 0, fontSize: '15px', fontWeight: '800' }}>Payment Screenshot</h4>
              <button onClick={() => setPreviewImage(null)} style={{ border: 'none', background: 'none', cursor: 'pointer' }}><FiX size={18} /></button>
            </div>
            <img src={previewImage} alt="Receipt" style={{ width: '100%', maxHeight: '70vh', objectFit: 'contain', borderRadius: '8px' }} />
          </div>
        </div>
      )}

    </div>
  );
}

const styles = {
  shell: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: colors.bgLight,
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
  sidebar: {
    width: '260px',
    backgroundColor: colors.deepNavy,
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    zIndex: 1000,
    transition: 'transform 0.3s ease',
  },
  sidebarBrand: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  },
  brandBadge: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    backgroundColor: 'rgba(99, 222, 204, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandText: {
    fontSize: '18px',
    fontWeight: '900',
    color: colors.white,
    margin: 0,
    letterSpacing: '-0.5px',
  },
  sidebarBadge: {
    fontSize: '9px',
    fontWeight: '800',
    color: colors.cyan,
    letterSpacing: '1px',
    display: 'block',
  },
  navigationMenu: {
    padding: '20px 14px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
  menuGroupHeading: {
    fontSize: '10px',
    fontWeight: '800',
    color: '#64748b',
    letterSpacing: '0.8px',
    padding: '0 8px 6px 8px',
  },
  navButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 14px',
    borderRadius: '10px',
    border: 'none',
    fontSize: '13px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'all 0.15s ease',
    width: '100%',
  },
  pendingIndicator: {
    marginLeft: 'auto',
    backgroundColor: colors.orange,
    color: colors.white,
    fontSize: '10px',
    fontWeight: '800',
    padding: '1px 6px',
    borderRadius: '10px',
  },
  sidebarFooter: {
    padding: '16px',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
  },
  sidebarLogoutBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: '#fff1f2',
    color: colors.danger,
    fontSize: '12px',
    fontWeight: '800',
    cursor: 'pointer',
  },
  mainShell: {
    flex: 1,
    marginLeft: '260px',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  topBar: {
    height: '68px',
    backgroundColor: colors.white,
    borderBottom: `1px solid ${colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 28px',
    position: 'sticky',
    top: 0,
    zIndex: 900,
  },
  mobileHamburger: {
    display: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: colors.textMain,
  },
  activeMenuHeading: {
    fontSize: '18px',
    fontWeight: '900',
    color: colors.textMain,
    margin: 0,
  },
  userProfilePill: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: colors.bgLight,
    border: `1px solid ${colors.border}`,
    padding: '6px 12px',
    borderRadius: '12px',
    cursor: 'pointer',
  },
  avatar: {
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    backgroundColor: colors.blue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileTextWrap: {
    textAlign: 'left',
  },
  profileRoleText: {
    fontSize: '9px',
    fontWeight: '800',
    color: colors.blue,
    display: 'block',
  },
  profileEmailText: {
    fontSize: '12px',
    fontWeight: '700',
    color: colors.textMain,
  },
  profileDropdown: {
    position: 'absolute',
    right: 0,
    top: '48px',
    width: '200px',
    backgroundColor: colors.white,
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    border: `1px solid ${colors.border}`,
    padding: '6px',
    zIndex: 1001,
  },
  divider: {
    height: '1px',
    backgroundColor: colors.border,
    margin: '4px 0',
  },
  dropdownLogout: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    width: '100%',
    padding: '8px 10px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: '#fff1f2',
    color: colors.danger,
    fontSize: '12px',
    fontWeight: '700',
    cursor: 'pointer',
  },
  contentWrap: {
    padding: '28px',
    flex: 1,
  },
  mobileBackdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(11, 12, 38, 0.65)',
    zIndex: 999,
  },
  kpiGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  kpiCard: {
    backgroundColor: colors.white,
    borderRadius: '16px',
    padding: '18px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    border: `1px solid ${colors.border}`,
    boxShadow: '0 4px 12px rgba(15, 17, 55, 0.02)',
  },
  kpiIconWrap: (color) => ({
    width: '46px',
    height: '46px',
    borderRadius: '12px',
    backgroundColor: `${color}15`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  kpiLabel: {
    fontSize: '11px',
    fontWeight: '800',
    color: colors.muted,
    margin: '0 0 2px 0',
  },
  kpiValue: {
    fontSize: '24px',
    fontWeight: '900',
    color: colors.textMain,
    margin: 0,
  },
  newAlertBadge: {
    backgroundColor: colors.orange,
    color: '#fff',
    fontSize: '10px',
    padding: '2px 7px',
    borderRadius: '10px',
    marginLeft: '4px',
  },
  tableCard: {
    backgroundColor: colors.white,
    borderRadius: '18px',
    border: `1px solid ${colors.border}`,
    overflow: 'hidden',
    boxShadow: '0 4px 14px rgba(15, 17, 55, 0.03)',
  },
  tableControlRow: {
    padding: '20px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '14px',
    borderBottom: `1px solid ${colors.border}`,
  },
  cardHeading: {
    fontSize: '16px',
    fontWeight: '800',
    color: colors.textMain,
    margin: '0 0 2px 0',
  },
  cardSub: {
    fontSize: '12px',
    color: colors.muted,
    margin: 0,
  },
  actionControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: colors.bgLight,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    padding: '0 10px',
    height: '38px',
    width: '240px',
  },
  searchInput: {
    border: 'none',
    background: 'transparent',
    outline: 'none',
    fontSize: '12px',
    width: '100%',
  },
  refreshBtn: {
    width: '38px',
    height: '38px',
    borderRadius: '8px',
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.bgLight,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'left',
  },
  tableHeadRow: {
    backgroundColor: '#fafbfc',
    borderBottom: `1px solid ${colors.border}`,
  },
  th: {
    padding: '12px 18px',
    fontSize: '11px',
    fontWeight: '800',
    color: colors.muted,
    textTransform: 'uppercase',
  },
  tableRow: {
    borderBottom: `1px solid ${colors.border}`,
  },
  tdId: {
    padding: '14px 18px',
    fontSize: '12px',
    fontWeight: '800',
    color: colors.muted,
  },
  td: {
    padding: '14px 18px',
    fontSize: '13px',
    verticalAlign: 'middle',
  },
  hostIdentity: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  tableAvatar: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    backgroundColor: 'rgba(47, 49, 148, 0.08)',
    color: colors.blue,
    fontWeight: '800',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hostName: {
    fontWeight: '700',
    color: colors.textMain,
  },
  hostEmail: {
    fontSize: '12px',
    color: colors.muted,
    display: 'flex',
    alignItems: 'center',
  },
  badge: {
    padding: '4px 10px',
    borderRadius: '16px',
    fontSize: '11px',
    fontWeight: '800',
  },
  toggleBtn: {
    border: 'none',
    borderRadius: '6px',
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: '800',
    cursor: 'pointer',
  },
  modalBackdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(11, 12, 38, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
    padding: '20px',
  },
  modalCard: {
    backgroundColor: colors.white,
    borderRadius: '16px',
    padding: '18px',
    maxWidth: '600px',
    width: '100%',
  },
};